import { render, staticRenderFns } from "./BotDetectHistory.vue?vue&type=template&id=3fccd5ca"
import script from "./BotDetectHistory.vue?vue&type=script&lang=js"
export * from "./BotDetectHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports